// extracted by mini-css-extract-plugin
export default {"newTabLinkIcon":"personalInfoPolicyContent_newTabLinkIcon__abTJk","paddingBottom":"personalInfoPolicyContent_paddingBottom__p3mYd","title":"personalInfoPolicyContent_title__X6U3x"};